/**
 * Centralised pdf.js worker configuration.
 *
 * We bundle the worker with the app (Vite `?url`) instead of loading it from a
 * CDN. The previous setup pointed `workerSrc` at
 *   //cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.min.js
 * which 404s for pdfjs-dist v5: v5 ships only `.mjs` workers and cdnjs does not
 * serve a `.min.js` worker for those versions. The dead worker made every
 * `getDocument()` throw ("We couldn't read that PDF") across the contract
 * editor. The bundled URL always matches the installed pdfjs-dist version and
 * needs no network.
 *
 * Import this module for its side effect anywhere pdf.js is used:
 *   import '@/lib/pdfWorker';
 */
import * as pdfjsLib from 'pdfjs-dist';
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl;
